<script lang="ts">
</script>
<oc-button-v1 data-sveltekit-reload href="/myaccount/dashboard">
	Zurück zu Mein Konto
</oc-button-v1>
